// symbols that should not be considered part of a word. e.g. comma after a word like "because,"
export const PUNCTUATIONS = [',', '.', '?', ' ']
